import { createAction } from '@reduxjs/toolkit';

import { NotificationItem } from '../types';

export const notificationsRequest = createAction('notifications/request');

export const notificationsSuccess = createAction<{ items: NotificationItem[] }>(
	'notifications/success',
);
export const notificationsFailure = createAction<string>('notifications/failure');

export const markReadRequest = createAction<{ notificationId: string }>(
	'notifications/markRead/request',
);
export const markReadSuccess = createAction<{ notificationId: string }>(
	'notifications/markRead/success',
);
export const markReadFailure = createAction<string>('notifications/markRead/failure');

export const markSeenRequest = createAction<{ notificationId: string }>(
	'notifications/markSeen/request',
);
export const markSeenSuccess = createAction<{ notificationId: string }>(
	'notifications/markSeen/success',
);
export const markSeenFailure = createAction<string>('notifications/markSeen/failure');

export const markAllSeenRequest = createAction('notifications/markAllSeen/request');
export const markAllSeenSuccess = createAction('notifications/markAllSeen/success');
export const markAllSeenFailure = createAction<string>('notifications/markAllSeen/failure');

export const notificationsClear = createAction('notifications/clear');
